import styled from '@emotion/styled';
import { CUSTOM_BREAK_POINT } from './Blocks/Block.styled';

const MenuToggle = ({ isOpen, setOpen }) => {
  return (
    <StyledBurger isOpen={isOpen} onClick={setOpen}>
      <div />
      <div />
      <div />
    </StyledBurger>
  );
};

const StyledBurger = styled.button<{ isOpen: boolean }>`
  display: none;
  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: absolute;

    right: 15px;
    top: 64px;
    width: 2rem;
    height: 2rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;

    &:focus {
      outline: none;
    }

    div {
      width: 2rem;
      height: 0.25rem;
      background: #effffa;
      border-radius: 10px;
      transition: all 0.3s linear;
      position: relative;
      transform-origin: 1px;

      :first-of-type {
        transform: ${({ isOpen }) => (isOpen ? 'rotate(45deg)' : 'rotate(0)')};
      }

      :nth-of-type(2) {
        opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
        transform: ${({ isOpen }) =>
          isOpen ? 'translateX(-20px)' : 'translateX(0)'};
      }

      :nth-of-type(3) {
        transform: ${({ isOpen }) => (isOpen ? 'rotate(-45deg)' : 'rotate(0)')};
      }
    }
  }
`;

export default MenuToggle;
